import { computed, Ref } from 'vue';
import { useStore } from 'vuex';
import { AdpDocument } from '@/types';

export const useAdpDocumentMarkPresentation = (
  adpDocument: Ref<AdpDocument | undefined>,
) => {
  const store = useStore();
  const userInfo = computed(() => store.state.userInfo.userInfo);

  const isMarked = computed(() => {
    if (!userInfo.value || !adpDocument.value) return false;
    return (adpDocument.value.marks ?? []).some(
      mark => mark.user_id === userInfo.value.id,
    );
  });

  const markedUsers = computed(() =>
    (adpDocument.value?.marks ?? []).map(mark => ({
      id: mark.user_id,
      name: mark.user_name,
    })),
  );

  const markedGroups = computed(() =>
    (adpDocument.value?.group_marks ?? []).map(groupMark => ({
      id: groupMark.group_id,
      name: groupMark.group_name,
    })),
  );

  const commentedUsers = computed(() =>
    (adpDocument.value?.comments ?? []).map(comment => ({
      id: comment.user_id,
      name: comment.user_name,
      commentId: comment.id,
    })),
  );

  return { isMarked, markedUsers, markedGroups, commentedUsers };
};
